import { NgModule } from '@angular/core';
import { PSmallSpinnerComponent } from './p-small-spinner.component';

@NgModule({
    declarations: [PSmallSpinnerComponent],
    exports: [PSmallSpinnerComponent]
})
export class PSmallSpinnerModule {}
